import { render, staticRenderFns } from "./smart_route_assignments_tbn.vue?vue&type=template&id=25e33d60&scoped=true&"
import script from "./smart_route_assignments_tbn.vue?vue&type=script&lang=js&"
export * from "./smart_route_assignments_tbn.vue?vue&type=script&lang=js&"
import style0 from "./smart_route_assignments_tbn.vue?vue&type=style&index=0&id=25e33d60&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25e33d60",
  null
  
)

export default component.exports